export default "__VITE_ASSET__Bd6p$b2R__"